var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.isMobile)?_c('NavigationBar'):_c('AppBar')],1),_c('div',{staticStyle:{"margin-top":"83px!important"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }